import { render, staticRenderFns } from "./brave-form.vue?vue&type=template&id=7c263f8a&scoped=true"
import script from "./brave-form.vue?vue&type=script&lang=js"
export * from "./brave-form.vue?vue&type=script&lang=js"
import style0 from "./brave-form.vue?vue&type=style&index=0&id=7c263f8a&prod&lang=scss&scoped=true"
import style1 from "./brave-form.vue?vue&type=style&index=1&id=7c263f8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c263f8a",
  null
  
)

export default component.exports